<!-- Registration Check Modal -->
<div
  class="modal-backdrop"
  *ngIf="showRegistrationModal"
  (click)="closeModal()"
>
  <div
    class="modal-content registration-modal"
    (click)="$event.stopPropagation()"
  >
    <button class="close-btn" (click)="closeModal()">×</button>
    <h2>Are you a registered stakeholder?</h2>
    <p>
      To book an appointment, confirm your registration with the NFM Recycling
      Portal
    </p>
    <div class="modal-buttons">
      <button class="btn-secondary" (click)="onRegistrationResponse(false)">
        No
      </button>
      <button class="btn-primary" (click)="onRegistrationResponse(true)">
        Yes
      </button>
    </div>
  </div>
</div>

<!-- Please Login Modal -->
<div class="modal-backdrop" *ngIf="showLoginModal" (click)="closeModal()">
  <div class="modal-content login-modal" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="onCloseLoginModal()">×</button>
    <h3>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <mask
          id="mask0_10502_40581"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_10502_40581)">
          <path
            d="M11 17.5H13V11.5H11V17.5ZM12 9.5C12.2833 9.5 12.5208 9.40417 12.7125 9.2125C12.9042 9.02083 13 8.78333 13 8.5C13 8.21667 12.9042 7.97917 12.7125 7.7875C12.5208 7.59583 12.2833 7.5 12 7.5C11.7167 7.5 11.4792 7.59583 11.2875 7.7875C11.0958 7.97917 11 8.21667 11 8.5C11 8.78333 11.0958 9.02083 11.2875 9.2125C11.4792 9.40417 11.7167 9.5 12 9.5ZM12 22.5C10.6167 22.5 9.31667 22.2375 8.1 21.7125C6.88333 21.1875 5.825 20.475 4.925 19.575C4.025 18.675 3.3125 17.6167 2.7875 16.4C2.2625 15.1833 2 13.8833 2 12.5C2 11.1167 2.2625 9.81667 2.7875 8.6C3.3125 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.8125 8.1 3.2875C9.31667 2.7625 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.8833 21.7375 15.1833 21.2125 16.4C20.6875 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1875 15.9 21.7125C14.6833 22.2375 13.3833 22.5 12 22.5Z"
            fill="#014221"
          />
        </g>
      </svg>
      Please Log In to Continue
    </h3>
    <p>
      You must be logged in as a registered stakeholder to book an appointment.
    </p>
    <button class="btn-primary" (click)="onGoToLogin()">Go to Login</button>
  </div>
</div>

<!-- Appointment Request Modal -->
<div class="modal-backdrop" *ngIf="showAppointmentModal" (click)="closeModal()">
  <div
    class="modal-content appointment-modal"
    (click)="$event.stopPropagation()"
  >
    <button class="close-btn" (click)="closeModal()">×</button>
    <h3>Request an Appointment</h3>

    <form [formGroup]="appointmentForm" (ngSubmit)="onSubmitAppointment()">
      <div class="form-row">
        <div class="form-group">
          <label for="fullName">Full Name<span class="required">*</span></label>
          <input
            id="fullName"
            type="text"
            formControlName="fullName"
            placeholder="Enter your Name"
            [class.error]="hasError('fullName')"
          />
          <div class="error-message" *ngIf="hasError('fullName')">
            {{ getErrorMessage("fullName") }}
          </div>
        </div>
        <div class="form-group">
          <label for="organizationName"
            >Organization Name<span class="required">*</span></label
          >
          <input
            id="organizationName"
            type="text"
            formControlName="organizationName"
            placeholder="Enter Organization Name"
            [class.error]="hasError('organizationName')"
          />
          <div class="error-message" *ngIf="hasError('organizationName')">
            {{ getErrorMessage("organizationName") }}
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="email"
            >Email Address<span class="required">*</span></label
          >
          <input
            id="email"
            type="email"
            formControlName="email"
            placeholder="Enter your Email Address"
            [class.error]="hasError('email')"
          />
          <div class="error-message" *ngIf="hasError('email')">
            {{ getErrorMessage("email") }}
          </div>
        </div>
        <div class="form-group">
          <label for="phoneNumber"
            >Phone Number<span class="required">*</span></label
          >
          <input
            id="phoneNumber"
            type="tel"
            formControlName="phoneNumber"
            placeholder="Enter your Phone Number"
            [class.error]="hasError('phoneNumber')"
            maxlength="10"
          />
          <div class="error-message" *ngIf="hasError('phoneNumber')">
            {{ getErrorMessage("phoneNumber") }}
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="selectDate"
            >Select Date<span class="required">*</span></label
          >
          <input
            id="selectDate"
            type="date"
            formControlName="selectDate"
            placeholder="Select Date"
            [class.error]="hasError('selectDate')"
            [min]="today"
            (change)="onDateChange()"
          />
          <div class="error-message" *ngIf="hasError('selectDate')">
            {{ getErrorMessage("selectDate") }}
          </div>
        </div>
        <div class="form-group">
          <label for="selectTime"
            >Select Time<span class="required">*</span></label
          >
          <input
            id="selectTime"
            type="time"
            formControlName="selectTime"
            class="form-control"
            [class.error]="hasError('selectTime')"
          />
          <div class="error-message" *ngIf="hasError('selectTime')">
            {{ getErrorMessage("selectTime") }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="purposeOfAppointment"
          >Purpose of Appointment<span class="required">*</span></label
        >
        <textarea
          id="purposeOfAppointment"
          formControlName="purposeOfAppointment"
          placeholder="Please provide the purpose for this appointment..."
          rows="4"
          maxlength="500"
          [class.error]="hasError('purposeOfAppointment')"
        ></textarea>
        <small class="text-muted"
          >{{ messageCharCount }}/{{ maxMessageLength }}</small
        >
        <div class="error-message" *ngIf="hasError('purposeOfAppointment')">
          {{ getErrorMessage("purposeOfAppointment") }}
        </div>
      </div>

      <button
        type="submit"
        class="btn-primary submit-btn"
        [disabled]="appointmentForm.invalid"
      >
        {{ isSubmitting ? "Sending OTP..." : "Send OTP" }}
      </button>
    </form>
  </div>
</div>

<!-- OTP Verification Modal - Fixed Version -->
<div class="modal-backdrop" *ngIf="showOtpModal" (click)="closeModal()">
  <div class="modal-content otp-modal" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeModal()">×</button>
    <h3>Enter OTP to Verify</h3>
    <p>
      An OTP has been sent to {{ appointmentForm.get("phoneNumber")?.value }}
    </p>

    <div class="otp-inputs">
      <ng-otp-input
        (onInputChange)="onOtpChange($event)"
        *ngIf="showOtpComponent"
        [config]="config"
      ></ng-otp-input>
    </div>

    <h6 class="mt-4">
      Did not get the OTP?
      <a
        class="cursor"
        (click)="onResendOtp()"
        (keydown.enter)="onResendOtp()"
        (keydown.space)="onResendOtp()"
        [class.disabled]="isDisabled"
        [attr.aria-disabled]="isDisabled"
        [attr.tabindex]="isDisabled ? -1 : 0"
      >
        Resend <span *ngIf="countdown !== 0">OTP in </span>
      </a>
      <span *ngIf="countdown !== 0">{{ formatTime(countdown) }}</span>
    </h6>

    <button class="btn-primary" (click)="onVerifyOtp()">
      {{ isSubmitting ? "Verifying..." : "Verify & Submit" }}
    </button>
  </div>
</div>

<!-- Success Modal -->
<div
  class="modal-backdrop"
  *ngIf="showSuccessModal"
  (click)="onCloseSuccessModal()"
>
  <div class="modal-content success-modal" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="onCloseSuccessModal()">×</button>
    <div class="success-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="103"
        height="103"
        viewBox="0 0 103 103"
        fill="none"
      >
        <mask
          id="mask0_10510_14664"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="103"
          height="103"
        >
          <rect width="103" height="103" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_10510_14664)">
          <path
            d="M45.4943 71.2413L75.7505 40.9851L69.7422 34.9768L45.4943 59.2247L33.263 46.9934L27.2547 53.0018L45.4943 71.2413ZM51.5026 94.4164C45.5658 94.4164 39.9866 93.2898 34.7651 91.0367C29.5436 88.7835 25.0016 85.7257 21.1391 81.8632C17.2766 78.0007 14.2188 73.4587 11.9656 68.2372C9.7125 63.0157 8.58594 57.4365 8.58594 51.4997C8.58594 45.5629 9.7125 39.9837 11.9656 34.7622C14.2188 29.5406 17.2766 24.9986 21.1391 21.1361C25.0016 17.2736 29.5436 14.2158 34.7651 11.9627C39.9866 9.70957 45.5658 8.58301 51.5026 8.58301C57.4394 8.58301 63.0186 9.70957 68.2401 11.9627C73.4616 14.2158 78.0037 17.2736 81.8662 21.1361C85.7287 24.9986 88.7865 29.5406 91.0396 34.7622C93.2927 39.9837 94.4193 45.5629 94.4193 51.4997C94.4193 57.4365 93.2927 63.0157 91.0396 68.2372C88.7865 73.4587 85.7287 78.0007 81.8662 81.8632C78.0037 85.7257 73.4616 88.7835 68.2401 91.0367C63.0186 93.2898 57.4394 94.4164 51.5026 94.4164Z"
            fill="#026432"
          />
        </g>
      </svg>
    </div>
    <h3>Your appointment request has been submitted.</h3>
    <p class="text-center">
      You will be notified via email or SMS once it is reviewed by the admin.
    </p>
    <div class="disclaimer">
      <mat-icon>info</mat-icon>
      <span>
        You can fill the form only after 10 days of submitting the appointment
        request or once it is approved by the admin.
      </span>
    </div>
  </div>
</div>
